module.exports = __webpack_public_path__ + "static/media/12UNCTAD3.d8103940.jpg";